import { mainReducer } from './_reducers';
import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk'

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const store = createStore(
    mainReducer,
    composeEnhancers(
        applyMiddleware(thunk),
    )
);

